import { auth } from "../config/firebase";

export const DEMO_EMAIL = "demo@futuredocument.com";

const STORAGE_KEY = "futuredoc_demo_mode";

let active = false;

try {
  active = localStorage.getItem(STORAGE_KEY) === "1";
} catch {
  active = false;
}

export function isDemoEmail(email) {
  return String(email || "").trim().toLowerCase() === DEMO_EMAIL;
}

export function setDemoMode(enabled) {
  active = !!enabled;
  try {
    if (enabled) localStorage.setItem(STORAGE_KEY, "1");
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** True when the signed-in (or last) session is the public demo account. */
export function isDemoMode(userOrUid) {
  try {
    const signedIn = auth?.currentUser?.email;
    if (signedIn) return isDemoEmail(signedIn);
  } catch {
    /* ignore */
  }
  if (isDemoEmail(userOrUid?.email)) return true;
  if (active) return true;
  if (!userOrUid) return false;
  if (typeof userOrUid === "string") {
    return userOrUid === "guest" || userOrUid === "demo-user";
  }
  if (userOrUid.uid === "guest" || userOrUid.uid === "demo-user") return true;
  return false;
}
